import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface EmailDetails {
  email_account_id: string;
  message_id: string;
}

export function useEmailDetails(emailMessageId: string | null) {
  return useQuery({
    queryKey: ['email-details', emailMessageId],
    queryFn: async () => {
      if (!emailMessageId) return null;

      const { data, error } = await supabase
        .from('email_messages')
        .select('email_account_id, message_id')
        .eq('id', emailMessageId)
        .single();

      if (error) throw error;
      return data as EmailDetails;
    },
    enabled: !!emailMessageId,
  });
}
